const FinanceIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15964_89364)">
      <path
        d="M11.2125 27.0022C11.7896 27.5089 12.3853 28.0316 12.9981 28.5736C13.0023 28.5773 13.0066 28.5811 13.0108 28.5848L15.0494 30.3457C15.3225 30.5816 15.6615 30.6996 16.0005 30.6996C16.3395 30.6996 16.6785 30.5815 16.9517 30.3457L18.9898 28.5848C18.9941 28.5811 18.9983 28.5774 19.0024 28.5737C23.0379 25.0049 26.0636 22.2726 28.2526 19.6079C30.8092 16.4957 32.0001 13.6817 32.0001 10.7521C32.0001 5.45199 27.8484 1.30029 22.5484 1.30029C20.1663 1.30029 17.8127 2.19726 16.0005 3.75212C14.1878 2.19717 11.8341 1.30029 9.45195 1.30029C4.15179 1.3002 0 5.45199 0 10.7521C0 17.1588 4.46061 21.0747 11.2125 27.0022ZM10.1805 13.0903H14.0601V9.21058H17.9398V13.0903H21.8195V16.9699H17.9398V20.8495H14.0601V16.9699H10.1805V13.0903Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15964_89364">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default FinanceIcon
